export default __webpack_public_path__ + "static/doc-blob-cd199131ef7b5248f51a3c13e8ec31bc.png";